(function () {
 'use strict';
var LAUNCHER_ICONS = {
		chat: 'M20 2H4a2 2 0 0 0-2 2v18l4-4h14a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2Zm-2 9H6v-2h12v2Zm0-3H6V6h12v2Zm-7 6H6v-2h5v2Z',
		bubble: 'M12 3C6.5 3 2 6.6 2 11c0 2.4 1.3 4.5 3.4 6L4 21l4.6-2.3c1.1.3 2.2.4 3.4.4 5.5 0 10-3.6 10-8.1S17.5 3 12 3z',
		question: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 17h-2v-2h2v2zm2.07-7.75l-.9.92C13.45 12.9 13 13.5 13 15h-2v-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2s-2 .9-2 2H8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 .88-.36 1.68-.93 2.25z',
		headset: 'M12 1c-4.97 0-9 4.03-9 9v7c0 1.66 1.34 3 3 3h3v-8H5v-2c0-3.87 3.13-7 7-7s7 3.13 7 7v2h-4v8h4v1h-7v2h6c1.66 0 3-1.34 3-3V10c0-4.97-4.03-9-9-9z',
		spark: 'M12 2l2.4 6.6L21 11l-6.6 2.4L12 20l-2.4-6.6L3 11l6.6-2.4L12 2zm7 13l.9 2.1L22 18l-2.1.9L19 21l-.9-2.1L16 18l2.1-.9L19 15z'
	};
	/** Strict visual CSS subset shared with AIWC_Appearance_CSS; no external resources. */
	function sanitizeCustomCss(value) {
		if (typeof value !== 'string') { return ''; }
		try { if (new TextEncoder().encode(value).length > 12000) { return ''; } } catch (error) { return ''; }
		value = value.trim();
		if (!value || /[\\<>@\x00-\x08\x0b\x0c\x0e-\x1f\x7f]|\/\*|\*\/|url\s*\(|expression\s*\(|javascript\s*:|behavior\s*:|-moz-binding/iu.test(value)) { return ''; }
		var allowed = ["color", "background-color", "border", "border-color", "border-width", "border-style", "border-radius", "border-top", "border-bottom", "border-left", "border-right", "padding", "padding-top", "padding-right", "padding-bottom", "padding-left", "margin", "margin-top", "margin-right", "margin-bottom", "margin-left", "gap", "row-gap", "column-gap", "width", "min-width", "max-width", "height", "min-height", "max-height", "font-size", "font-weight", "font-style", "line-height", "letter-spacing", "text-align", "text-decoration", "box-shadow", "opacity", "display", "align-items", "justify-content"];
		var pattern = /\s*([^{}]+)\{([^{}]*)\}\s*/y, offset = 0, count = 0, match;
		while (offset < value.length) {
			pattern.lastIndex = offset; match = pattern.exec(value);
			if (!match || ++count > 64) { return ''; }
			if (!match[1].trim().split(',').every(function (selector) { return /^\s*(?:\.aiwc-[a-z0-9_-]+|:host(?:\([^{}]+\))?)[a-z0-9_\s.#:\[\]="'()*+~|>\-]*$/i.test(selector); })) { return ''; }
			var declarations = match[2].split(';').filter(function (item) { return item.trim() !== ''; });
			if (declarations.length > 64 || !declarations.every(function (item) {
				var parts = /^\s*([a-z-]+)\s*:\s*([^{};]+)\s*$/i.exec(item);
				if (!parts || allowed.indexOf(parts[1].toLowerCase()) === -1) { return false; }
				var functions = parts[2].matchAll(/([a-z_-][a-z0-9_-]*)\s*\(/gi);
				for (var found of functions) { if (['rgb','rgba','hsl','hsla','calc','min','max','clamp','var'].indexOf(found[1].toLowerCase()) === -1) { return false; } }
				return true;
			})) { return ''; }
			offset = pattern.lastIndex;
		}
		return value;
	}

 if (window.__aiwcLauncher || (window.__aiwcRuntime && window.__aiwcRuntime.booted)) { return; }
 var config = window.aiwcConfig || {}, pending = null, observer, viewportObserver, launchers = [], deferredTemplate;
 var runtime = window.__aiwcRuntime = window.__aiwcRuntime || { widgets: [], beforeSendInterceptors: [], responseHandlers: [] };
 runtime.hooks = runtime.hooks || {
  filters: {},
  addFilter: function (name, callback, priority) {
   if (typeof name !== 'string' || !name || typeof callback !== 'function') { return; }
   (this.filters[name] = this.filters[name] || []).push({ callback: callback, priority: Number(priority) || 10 });
   this.filters[name].sort(function (a, b) { return a.priority - b.priority; });
  },
  applyFilters: function (name, value) {
   var args = Array.prototype.slice.call(arguments, 1);
   (this.filters[name] || []).forEach(function (filter) { args[0] = filter.callback.apply(null, args); });
   return args[0];
  }
 };
 function loadI18n() {
  if (window.wp && window.wp.i18n) { return Promise.resolve(); }
  return (Array.isArray(config.i18nScripts) ? config.i18nScripts : []).reduce(function (ready, url) {
   return ready.then(function () { return new Promise(function (resolve, reject) {
    var script = document.createElement('script'); script.src = url; script.onload = resolve;
    script.onerror = function () { script.remove(); reject(new Error('Chat translations could not load.')); };
    document.head.appendChild(script);
   }); });
  }, Promise.resolve());
 }
 function hydrate() {
  if (!deferredTemplate) { return; }
  document.querySelectorAll('.aiwc-widget-host[data-aiwc-deferred]').forEach(function (host) {
   var current = host.querySelector('.aiwc-widget-template');
   if (current) { current.replaceWith(deferredTemplate.cloneNode(true)); host.removeAttribute('data-aiwc-deferred'); }
  });
 }
 function loadConfiguration() {
  if (!config.bootstrapUrl) { return Promise.resolve(); }
  var url;
  try { url = new URL(config.bootstrapUrl, window.location.href); } catch (error) { return Promise.reject(new Error('Chat configuration could not load.')); }
  if (url.origin !== window.location.origin) { return Promise.reject(new Error('Chat configuration must use this site.')); }
  return fetch(url.href, { credentials: 'omit', cache: 'no-store', redirect: 'error', headers: { 'X-AIWC-Launcher': '1' } }).then(function (response) {
   if (!response.ok) { throw new Error('Chat configuration could not load.'); }
   return response.json();
  }).then(function (response) {
   var data = response && response.success && response.data;
   if (!data || !data.config || typeof data.config !== 'object' || typeof data.markup !== 'string') { throw new Error('Chat configuration is invalid.'); }
   var fragment = document.createElement('template'); fragment.innerHTML = data.markup;
   var template = fragment.content.querySelector('.aiwc-widget-host > .aiwc-widget-template');
   if (!template || !template.content.querySelector('.aiwc-chat-container') || !data.config.runtimeUrl) { throw new Error('Chat markup is unavailable.'); }
   deferredTemplate = template; hydrate();
   config = data.config; window.aiwcConfig = config;
  });
 }
 function load() {
  if (pending) { return pending; }
  pending = loadConfiguration().then(loadI18n).then(function () { return new Promise(function (resolve, reject) {
   var script = document.createElement('script'); script.src = config.runtimeUrl; script.defer = true;
   script.onload = function () {
    if (observer && !deferredTemplate) { observer.disconnect(); }
    launchers.forEach(function (item) { item.nodes.forEach(function (node) { node.remove(); }); });
    launchers = [];
    if (window.AIWebChat === api) { pending = null; reject(new Error('Chat runtime did not initialize.')); return; }
    resolve(window.AIWebChat);
   };
   script.onerror = function () { pending = null; script.remove(); reject(new Error('Chat could not load. Please try again.')); };
   document.head.appendChild(script);
  }); }).catch(function (error) { pending = null; throw error; });
  return pending;
 }
 function activate(host) {
  var button = host && host.shadowRoot && host.shadowRoot.querySelector('[data-aiwc-eager]');
  if (button) { button.setAttribute('aria-busy', 'true'); }
  return load().then(function () {
   var widget = runtime.widgets.filter(function (item) { return item.host === host; })[0];
   if (widget) { widget.open({ focus: true }); } else { window.AIWebChat.open(); }
  }).catch(function () { if (button) { button.removeAttribute('aria-busy'); button.focus(); } });
 }
 function unmount(root) {
  root = root || document;
  launchers = launchers.filter(function (item) {
   if (root === item.host || (root.contains && root.contains(item.host))) {
    item.host.__aiwcAutoMountSuppressed = true; delete item.host.__aiwcEager;
    item.nodes.forEach(function (node) { node.remove(); }); return false;
   }
   return true;
  });
  return [];
 }
 var api = window.AIWebChat = {
  version: '2.0.0', instances: function () { return runtime.widgets.slice(); }, hooks: runtime.hooks,
  open: function (options) { return load().then(function (full) { return full.open(options); }); },
  toggle: function (options) { return load().then(function (full) { return full.toggle(options); }); },
  send: function (message) { return load().then(function (full) { return full.send(message); }); },
  mount: function (root) { return load().then(function (full) { return full.mount(root); }); },
  refresh: function (root) { return load().then(function (full) { return full.refresh(root); }); },
  close: function () { if (pending) { return pending.then(function (full) { return full.close(); }); } },
  unmount: function (root) { unmount(root); if (pending) { return pending.then(function (full) { return full.unmount(root); }); } return []; },
  destroy: function (root) { unmount(root); if (!root && observer) { observer.disconnect(); } if (pending) { return pending.then(function (full) { return full.destroy(root); }); } return []; },
  clearHistory: function () { return load().then(function (full) { return full.clearHistory(); }); },
  getSessionId: function () { return null; }, isOpen: function () { return false; },
  onBeforeSend: function (callback) { if (typeof callback === 'function') { runtime.beforeSendInterceptors.push(callback); } },
  onResponse: function (callback) { if (typeof callback === 'function') { runtime.responseHandlers.push(callback); } }
 };
 function clamp(value, min, max, fallback) { value = Number(value); return Number.isFinite(value) ? Math.max(min, Math.min(max, value)) : fallback; }
 function mount(host) {
  if (host.__aiwcEager || host.__aiwcMountedWidget || host.__aiwcAutoMountSuppressed) { return; }
  if (config.preview) { load().catch(function () {}); return; }
  if (host.getAttribute('data-aiwc-mode') === 'shortcode') {
   if (typeof IntersectionObserver !== 'function') { load().catch(function () {}); return; }
   if (!viewportObserver) { viewportObserver = new IntersectionObserver(function (entries) { if (entries.some(function (entry) { return entry.isIntersecting; })) { viewportObserver.disconnect(); load().catch(function () {}); } }, {rootMargin:'100px'}); }
   host.__aiwcEager = true; viewportObserver.observe(host); return;
  }
  var template = host.querySelector('.aiwc-widget-template');
  var original = template && template.content && template.content.querySelector('.aiwc-toggle-btn');
  if (!original || typeof host.attachShadow !== 'function') { load().catch(function () {}); return; }
  host.__aiwcEager = true;
  var root = host.shadowRoot || host.attachShadow({ mode: 'open' });
  var style = document.createElement('link'); style.rel = 'stylesheet'; style.href = config.launcherCssUrl; style.setAttribute('data-aiwc-launcher', '');
  var button = original.cloneNode(true); button.setAttribute('data-aiwc-eager', '');
  var a = config.appearance || {}, launcher = a.launcher || {}, mobile = a.mobile || {};
  host.setAttribute('data-aiwc-pos', a.position === 'left' ? 'left' : 'right');
  host.setAttribute('data-aiwc-launcher', /^(round|pill)$/.test(launcher.style) ? launcher.style : 'square');
  host.setAttribute('data-aiwc-m-label', mobile.label ? 'show' : 'hide');
  host.setAttribute('data-aiwc-animation', a.animation === 'fade' || a.animation === 'pulse' ? a.animation : 'none');
  host.__aiwcEntrancePlayed = true;
  var primary = /^#[a-f0-9]{6}$/i.test(a.primary) ? a.primary : '#0073aa';
  host.style.setProperty('--aiwc-primary', primary);
  host.style.setProperty('--aiwc-on-primary', /^#[a-f0-9]{6}$/i.test(a.onPrimary) ? a.onPrimary : '#ffffff'); button.style.background = primary;
  [['d-offset-x',a.offsetX,0,400,24],['d-offset-y',a.offsetY,0,400,24],['d-launcher-size',launcher.size,40,80,68],['m-offset-x',mobile.offsetX,0,200,14],['m-offset-y',mobile.offsetY,0,200,14],['m-launcher-size',mobile.size,40,80,clamp(launcher.size,40,80,68)]].forEach(function (entry) { host.style.setProperty('--aiwc-' + entry[0], clamp(entry[1],entry[2],entry[3],entry[4]) + 'px'); });
  var label = button.querySelector('.aiwc-toggle-label');
  if (label && typeof launcher.label === 'string' && launcher.label.trim()) { label.textContent = launcher.label.trim().slice(0,30); label.hidden = false; if (launcher.style === 'pill') { button.setAttribute('aria-label', label.textContent); } }
  var image = button.querySelector('.aiwc-toggle-img');
  if (image && launcher.icon === 'image' && /^https?:\/\//i.test(launcher.image)) { image.src = launcher.image; image.hidden = false; button.classList.add('aiwc-toggle-has-image'); }
  var path = button.querySelector('.aiwc-icon-chat path');
  if (path && LAUNCHER_ICONS[launcher.icon]) { path.setAttribute('d', LAUNCHER_ICONS[launcher.icon]); }
  root.appendChild(style); root.appendChild(button);
  var nodes = [style, button];
  if (typeof sanitizeCustomCss === 'function') {
   var customCss = sanitizeCustomCss(typeof a.customCss === 'string' ? a.customCss : '');
   if (customCss) { var customStyle = document.createElement('style'); customStyle.setAttribute('data-aiwc-lazy-custom-css', ''); customStyle.textContent = customCss; root.appendChild(customStyle); nodes.push(customStyle); }
  }
  launchers.push({ host: host, nodes: nodes });
  button.addEventListener('click', function () { activate(host); });
  button.addEventListener('pointerenter', prefetch, {once:true}); button.addEventListener('focus', prefetch, {once:true});
 }
 function scan() {
  hydrate();
  if (runtime.booted) { return; }
  document.querySelectorAll('.aiwc-widget-host').forEach(mount);
  if (Array.prototype.some.call(document.querySelectorAll('.aiwc-chat-container'), function (container) { return !container.closest('.aiwc-widget-host'); })) { load().catch(function () {}); }
 }
 function prefetch() {
  if (document.querySelector('link[data-aiwc-prefetch]') || !config.runtimeUrl) { return; }
  [config.runtimeUrl,config.cssUrl].forEach(function (url) { if (!url) { return; } var link = document.createElement('link'); link.rel = 'prefetch'; link.href = url; link.setAttribute('data-aiwc-prefetch',''); document.head.appendChild(link); });
 }
 function boot() {
  scan();
  if (typeof requestIdleCallback === 'function') { requestIdleCallback(prefetch, {timeout:3000}); }
  observer = new MutationObserver(scan); observer.observe(document.documentElement, { childList: true, subtree: true });
  // Proactive experiences load when due; the default closed launcher stays dormant.
  if (config.opener) { setTimeout(function () { config.opener.delaySeconds = 0; load().catch(function () {}); }, Math.max(0, Number(config.opener.delaySeconds) || 0) * 1000); }
  if (config.leadCapture && config.leadCapture.exitIntent) { document.addEventListener('mouseleave', function () { load().catch(function () {}); }, { once: true }); }
 }
 window.__aiwcLauncher = { load: load };
 if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', boot, { once: true }); } else { boot(); }
})();
